export default "__VITE_ASSET__BhGgiJ$___"